// extracted by mini-css-extract-plugin
export default {"img":"ForesightLogo_img__nTfWH","withBackground":"ForesightLogo_withBackground__bOndn"};